export const addOrMoveToStart = (str: string, arr: string[]) => {
	if (!arr.includes(str)) return [str, ...arr];

	const res = [...arr];
	res.splice(0, 0, ...res.splice(res.indexOf(str), 1));

	return res;
};
export const generateGoogleFontUrl = (fontName: string) =>
	`https://fonts.googleapis.com/css?family=${fontName}:100,200,300,400,500,600,700,800,900`;
